import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"logout\"><path d=\"M13 5H5v14h8v2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8zm4.17 6-2.58-2.59L16 7l5 5-5 5-1.41-1.41L17.17 13H9v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol